import { z } from 'zod';

import { passwordValidationZodSchema } from 'src/constants/validation';

import { ChangePasswordFormFields, ChangePasswordFormValues } from '../types';

export const changePasswordFormValidationSchema = z
  .object({
    [ChangePasswordFormFields.currentPassword]: z.string().nonempty('Required'),
    [ChangePasswordFormFields.newPassword]: passwordValidationZodSchema.nonempty('Required'),
    [ChangePasswordFormFields.confirmNewPassword]: passwordValidationZodSchema.nonempty('Required'),
  })
  .refine(data => data.newPassword !== data.currentPassword, {
    message: 'Current and new password must be different',
    path: [ChangePasswordFormFields.newPassword],
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    message: 'Passwords must match',
    path: [ChangePasswordFormFields.confirmNewPassword],
  }) satisfies z.ZodType<ChangePasswordFormValues>;

export const mfaCodeFormValidationSchema = z.object({
  [ChangePasswordFormFields.mfaCode]: z.string(),
});
